import FontBody2 from '../../../../../../../components/fonts/font-body2/font-body2';
import { FONT_COLOR, FONT_VARIANT } from '../../../../../../../components/fonts/font-props';

import EligibilityLevelIcon from '../../ui/eligibility-level-icon';
import { OrderEligibilityDisplayService } from '../../order-eligibility-display.service';

interface FailedCheckItemProps {
    check: {
        level: string;
        reason?: string;
        is_passed: boolean;
    };
    resolutionCategory?: string;
}

const FailedCheckItem: React.FC<FailedCheckItemProps> = ({ check, resolutionCategory }) => {
    return (
        <div className="failed-check-item">
            <div className="failed-check-header">
                <EligibilityLevelIcon level={check.level} />
                <FontBody2 color={FONT_COLOR.SEMANTIC_DANGER} variant={[FONT_VARIANT.BOLD]}>
                    {check.level}
                </FontBody2>
            </div>
            {check.reason && (
                <div className="failed-check-details">
                    <FontBody2 color={FONT_COLOR.SEMANTIC_DANGER}>
                        {OrderEligibilityDisplayService.formatFailedCheckReason(check.reason, resolutionCategory)}
                    </FontBody2>
                </div>
            )}
        </div>
    );
};

export default FailedCheckItem;
